/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Injectable,
  Input,
  OnDestroy,
  Output,
  TemplateRef,
  ViewChild, ViewContainerRef
} from '@angular/core'
import { NgClass } from '@angular/common';
import { HAMMER_GESTURE_CONFIG, HammerGestureConfig } from '@angular/platform-browser'
import 'hammerjs'
import { DIRECTION_HORIZONTAL } from 'hammerjs'

import {SwipeServiceService} from './swipe-service.service'
import { ResponsiveComponent } from '../responsive.component'
import { takeUntil } from 'rxjs'

@Injectable()
export class HammerConfig extends HammerGestureConfig {
  override overrides = {
    pan: {
      enable: true,
      touchAction: 'auto',
      direction: DIRECTION_HORIZONTAL
    },
    pinch: {
      enable: false
    },
    rotate: {
      enable: false
    },
    swipe: {
      enable: false
    }
  }
}
@Component({
  standalone: true,
  imports: [NgClass],
  selector: 'nx-superprep-swipe-item-list',
  templateUrl: './swipe-item-list.component.html',
  styleUrls: ['./swipe-item-list.component.scss'],
  providers: [{
    provide: HAMMER_GESTURE_CONFIG,
    useClass: HammerConfig
  }],
})
export class SwipeItemListComponent extends ResponsiveComponent implements OnDestroy, AfterViewInit {
  alive = true
  result!: boolean
  selfElement
  idElement
  @Input() inside!: {
    id: any
    title: string
    subTitle: string
    mark: boolean
  }

  @Input() disabledMark = false
  @Input() showMark = false
  @Input() itemClass = ''

  @ViewChild('defaultEdit') defaultEdit: TemplateRef<any> | null = null
  @ViewChild('defaultDel') defaultDel: TemplateRef<any> | null = null

  @ViewChild('defaultMark') defaultMark: TemplateRef<any> | null = null
  @ViewChild('defaultNotMark') defaultNotMark: TemplateRef<any> | null = null
  @ViewChild('defaultCustom') defaultCustom: TemplateRef<any> | null = null

  @Input() customTemplate: TemplateRef<any> | null = null
  @Input() editTemplate: TemplateRef<any> | null = null
  @Input() delTemplate: TemplateRef<any> | null = null
  @Input() markTemplate: TemplateRef<any> | null = null
  @Input() notMarkTemplate: TemplateRef<any> | null = null

  @Output() callback = new EventEmitter<any>()

  @Output() swClick = new EventEmitter<any>()

  @ViewChild('viewContainerEdit', { static: false, read: ViewContainerRef }) viewContainerEdit!: ViewContainerRef

  @ViewChild('viewContainerDel', { static: false, read: ViewContainerRef }) viewContainerDel!: ViewContainerRef

  @ViewChild('viewContainerMark', { static: false, read: ViewContainerRef }) viewContainerMark!: ViewContainerRef

  @ViewChild('viewContainerCustom', { static: false, read: ViewContainerRef }) viewContainerCustom!: ViewContainerRef

  // @ViewChild('tpl') tpl: TemplateRef<any>

  @HostListener('document:click', ['$event'])
  clickOut(event: any) {
    if (!this.selfElement.contains(event.target)) {
      this.result = false
    }
  }

  constructor(
    elRef: ElementRef,
    private swService: SwipeServiceService,
  ) {
    super()
    this.selfElement = elRef.nativeElement
    this.idElement = `list-swipe-${this.random()}`
    this.selfElement.setAttribute('data-id', this.idElement)
    this.selfElement.id = this.idElement
    this.swService.swipeObserver
    .pipe(takeUntil(this.onDestroy))
    .subscribe(a => {
      if (a !== this.selfElement.id) {
        this.result = false
      }
    })
  }

  private random = () => {
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
  }

  private getParent = (arr: any[] = []) => {
    return new Promise((resolve) => {
      arr.map((a: any) => {
        if (/list-swipe/.test(a.id)) {
          resolve(a.id)
        }
      })
    })
  }

  public swipeleft = (res:any) => {
    this.swService.closeAll(this.selfElement.id)
        if (!this.disabledMark) {
          this.result = (res.deltaX < 0)
        }
  }

  clickItem = (a: any) => this.swClick.emit(a)

  action = (opt = '') => {
    try {
      this.result = false
      const {id} = this.inside
      if (opt === 'edit') {
        this.callback.emit({action: 'edit', value: id})
      } else if (opt === 'del') {
        this.callback.emit({action: 'del', value: id})
      }
    } catch {
      console.log('You must define ID of edit, or del')
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
    if (this.showMark) {
      if (this.inside.mark && !this.markTemplate) {
        const viewMark = this.defaultMark?.createEmbeddedView(null)
        if (viewMark) { this.viewContainerMark.insert(viewMark); }
      } else if (this.inside.mark && this.markTemplate) {
        const viewMark = this.markTemplate.createEmbeddedView(null)
        this.viewContainerMark.insert(viewMark)
      }

      if (!this.inside.mark && !this.notMarkTemplate) {
        const viewMark = this.defaultNotMark?.createEmbeddedView(null)
        if (viewMark) { this.viewContainerMark.insert(viewMark); }
      } else if (!this.inside.mark && this.notMarkTemplate) {
        const viewMark = this.notMarkTemplate.createEmbeddedView(null)
        this.viewContainerMark.insert(viewMark)
      }
    }

    if (this.editTemplate) {
      const viewEdit = this.editTemplate.createEmbeddedView(null)
      if (this.viewContainerEdit) {
        this.viewContainerEdit.insert(viewEdit)
      }
    } else if (this.editTemplate !== null) {
      const viewEdit = this.defaultEdit?.createEmbeddedView(null)
      if (viewEdit) { this.viewContainerEdit.insert(viewEdit); }
    }

    if (this.delTemplate) {
      const viewDel = this.delTemplate.createEmbeddedView(null)
      if (this.viewContainerDel) {
        this.viewContainerDel.insert(viewDel)
      }
    } else if (this.delTemplate !== null) {
      const viewDel = this.defaultDel?.createEmbeddedView(null)
      if (viewDel) { this.viewContainerDel.insert(viewDel); }
    }

    // const hammer = new Hammer(this.selfElement)

      if (this.customTemplate) {
        const dataInside = {...this.inside, ...{touch: this.selfElement.id}}
        const viewCustomTemplate = this.customTemplate.createEmbeddedView({
          item: dataInside,
          id: this.selfElement.id
        })
        if (viewCustomTemplate && viewCustomTemplate.rootNodes) {
          viewCustomTemplate.rootNodes.map(e => {
            e.id = this.selfElement.id
            e.children[0].childNodes.forEach((b: { id: any; children: string | any[]; }) => {
              if (b) {
                b.id = this.selfElement.id
                if (b.children.length) {
                  b.children[0].id = this.selfElement.id
                }
              }
            })
          })
        }

        if (viewCustomTemplate) {
          this.viewContainerCustom.insert(viewCustomTemplate)
        }
      } else {
        const viewCustomTemplate = this.defaultCustom?.createEmbeddedView(null)
        if (viewCustomTemplate) { this.viewContainerCustom.insert(viewCustomTemplate); }
      }
    }, 50)
  }
}
